export default {
      id: "city-icon-3-usage",
      viewBox: "0 0 107 80",
      url: __webpack_public_path__ + "sprite.svg#city-icon-3",
      toString: function () {
        return this.url;
      }
    }